import Vue from 'vue'

// import all icons used in the app here.
import 'vue-awesome/icons/map-marker-alt'
import 'vue-awesome/icons/phone'
import 'vue-awesome/icons/envelope'

import Icon from 'vue-awesome/components/Icon'
Vue.component('icon', Icon)
